"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _menuItems = require("../../../../../constants/menuItems");
var _CreditsMenuItem = _interopRequireDefault(require("../../../../CreditsMenuItem/CreditsMenuItem.container"));
var _HomePageToggle = _interopRequireDefault(require("../../../../HomePageToggle"));
var _Text = _interopRequireDefault(require("../../../../Text/Text.render"));
var _SubMenu = require("../SubMenu.style");
const SubMenuWithItemsDefault = _ref => {
  let {
    text,
    showing,
    customRender
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SubMenu.SubMenuItemInner, {
    showing: showing
  }, text === 'HeaderMenus.ToolsAndServices.Credits' && /*#__PURE__*/_react.default.createElement(_CreditsMenuItem.default, null), !customRender && text !== 'HeaderMenus.ToolsAndServices.Credits' && /*#__PURE__*/_react.default.createElement(_Text.default, {
    type: "ButtonText",
    variant: "Primary",
    intlText: text
  }), customRender === _menuItems.CUSTOM_DROPDOWN_NEW_HOME_TOGGLE && /*#__PURE__*/_react.default.createElement(_HomePageToggle.default, {
    id: "new-homepage-toggle",
    key: "newHomepageToggle"
  }));
};
var _default = exports.default = SubMenuWithItemsDefault;